import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const InviteHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const inviteCode = searchParams.get('code');

    if (inviteCode) {
      // 保存邀请码到localStorage，用于注册时使用
      localStorage.setItem('inviteCode', inviteCode);
    }

    // 跳转到首页
    navigate('/');
  }, [searchParams, navigate]);

  return null;
};

export default InviteHandler;
